bam-subnavigation {
  position: relative;
  .sub-navigation__wrapper {
    @include tablet() {
      max-width: 100%;
      height: 73px;
      box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
      background: var(--bal-color-white);
      border-radius: var(--bal-radius-large);
      padding: 0 1rem;
    }
    .bal-tabs--context-navigation {
      height: auto;
    }
    .bal-tabs__tabs__item__button--context-navigation {
      height: auto;
      padding: 0.25rem 0.75rem;
      color: var(--bal-color-primary-3);
    }
    .bal-tabs__tabs__item__button--active {
      color: var(--bal-color-primary);
    }
  }
}
// Editmode Styles to prevent overflow
.editmode {
  bam-subnavigation {
    @include desktop() {
      .sub-navigation__wrapper {
        height: 100% !important;
      }
      nav {
        height: 100%;
      }
    }
  }
}
